import { render, staticRenderFns } from "./customerLogin.vue?vue&type=template&id=73142064&scoped=true"
import script from "./customerLogin.vue?vue&type=script&lang=js"
export * from "./customerLogin.vue?vue&type=script&lang=js"
import style0 from "./customerLogin.vue?vue&type=style&index=0&id=73142064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73142064",
  null
  
)

export default component.exports